import { render } from "./Blog2Column1Large.vue?vue&type=template&id=558df0aa&scoped=true"
import script from "./Blog2Column1Large.vue?vue&type=script&lang=js"
export * from "./Blog2Column1Large.vue?vue&type=script&lang=js"

import "./Blog2Column1Large.vue?vue&type=style&index=0&id=558df0aa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558df0aa"]])

export default __exports__